<template>
  <div class="account tab-wrap">
    <ul v-if="isUnfold" class="tab-container asideOut">
      <li>
        <div class="tab-chouti">
          <i class="iconfont icon-caidan-dakai anniu" @click="folding"></i>
        </div>
      </li>
      <li
        v-for="tab in tabs"
        :key="tab.id"
        :class="{active: activeTab === tab.id}"
        class="tab"
        @click="activeTab=tab.id"
      >
        <div class="tab-item" v-if="tab.id == 'account'">
          <i class="iconfont icon-accountSet"></i>
          <p>{{tab.label}}</p>
        </div>
        <div class="tab-item" v-if="tab.id == 'group'">
          <i class="iconfont icon-fenzu1"></i>
          <p>{{tab.label}}</p>
        </div>
      </li>
    </ul>
    <ul v-else class="tab-container asideIn">
      <li>
        <div class="tab-chouti">
          <i class="iconfont icon-caidan-shousuo anniu" @click="folding"></i>
        </div>
      </li>
      <li
        v-for="chouTab in tabs"
        :key="chouTab.id"
        :class="{active: activeTab === chouTab.id}"
        class="chouTab"
        @click="activeTab=chouTab.id"
      >
        <el-dropdown
          v-if="chouTab.id == 'account'"
          @command="handleAccountCommand"
          placement="right"
        >
          <el-button v-if="chouTab.id == 'account'" class="operation">
            <i class="iconfont iconChouti icon-accountSet"></i>
          </el-button>
          <el-dropdown-menu class="activeTabGroup" slot="dropdown">
            <el-dropdown-item :class="{active: activeTab === chouTab.id}" class="activeTabGroupItem" command="account">{{chouTab.label}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown
          v-if="chouTab.id == 'group'"
          @command="handleAccountCommand"
          placement="right"
        >
          <el-button v-if="chouTab.id == 'group'" class="operation">
            <i class="iconfont iconChouti icon-fenzu1"></i>
          </el-button>
          <el-dropdown-menu class="activeTabGroup" @click="activeTab=group" slot="dropdown">
            <el-dropdown-item :class="{active: activeTab === chouTab.id}" class="activeTabGroupItem" command="group">{{chouTab.label}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </li>
    </ul>
    <!-- <div class="breadcrumb">
      <el-breadcrumb
          separator="/"
          class="head-nav"
        >
        <el-breadcrumb-item :to="{ path: '/home' }">{{$t('menu.home')}}</el-breadcrumb-item>
        <el-breadcrumb-item style="cursor: pointer;" @click.native="back">返回上一级</el-breadcrumb-item>
        <el-breadcrumb-item v-if="activeTab == 'account'">{{$t('account.uselists')}}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="activeTab == 'group'">{{$t('group.Groups_list')}}</el-breadcrumb-item>
      </el-breadcrumb>
    <component :is="activeTab" class="tab-content"></component>
    </div> -->
    <component :is="activeTab" class="tab-content"></component>
  </div>
</template>
<script>
import account from "./account";
import group from "./group";
export default {
  components: {
    account,
    group
  },
  data() {
    return {
      isUnfold: true,
      activeTab: "account",
      tabs: [
        {
          id: "account",
          label: this.$t("account.accountManage")
        },
        {
          id: "group",
          label: this.$t("account.groupManage")
        }
      ]
    };
  },
  methods: {
    // back() {
    //   this.$router.go(-1)
    // },
    handleAccountCommand(command) {
      switch (command) {
        case "account":
          this.activeTab = "account";
          break;
        case "group":
          this.activeTab = "group";
          break;
        default:
          break;
      }
    },
    folding() {
      if (this.isUnfold) {
        this.isUnfold = !this.isUnfold;
      } else {
        this.isUnfold = !this.isUnfold;
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../../assets/css/mixin.less");
.activeTabGroup {
  background: @siderbarColor;
  margin-left: 30px;
}
.activeTabGroupItem {
  // background: #1890ff;
  color: #ffffff;
  border: none;
  margin: 5px 0;
  &:not(:last-child) {
    border-bottom: none;
  }
  &.active{
    background: @themeColor;
  }
  &:hover,
  &:focus {
    background: @themeColor;
    color: #ffffff;
  }
}
.iconfont {
  display: inline-block;
  font-size: 24px;
}
.asideOut {
  width: 256px !important;
  transition: all 0.3s linear 0s;
}
.asideIn {
  width: 80px !important;
  transition: all 0.3s linear 0s;
}
.anniu {
  font-size: 28px;
  color: #ffffff;
  cursor: pointer;
    &:hover,
  &:focus {
    color: @themeColor;
  }
}
</style>
